module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SL - Sierra Leone.08317c25.svg";